import { css } from "@compiled/react";
import { documentToHtmlString } from "@contentful/rich-text-html-renderer";
import { Document } from "@contentful/rich-text-types";

import { token } from "@atlaskit/tokens";

import { AgileVideo } from "@/components/agile-video/agile-video";
import { RichTextComponent } from "@/templates/agile-hub/src/sections/components/body-text";
import { TutorialIntroduction } from "@/templates/agile-hub/tutorial-types";

type Nullable<T> = T | null;

export interface UniformTutorialIntroductionContentProps {
    tutorialIntroduction: Nullable<TutorialIntroduction>;
}

function getRichText(richText: string | Document) {
    if (typeof richText === "string") {
        return richText;
    }

    return documentToHtmlString(richText);
}

// eslint-disable-next-line complexity
export const TutorialIntroductionContent = ({
    tutorialIntroduction
}: UniformTutorialIntroductionContentProps) => {
    return (
        <div
            data-testid="agile-hub-introduction-content"
            css={css({
                display: "flex",
                flexDirection: "column",
                gap: token("space.250")
            })}
        >
            {tutorialIntroduction?.tutorialIntroductionName && (
                <h2
                    css={css({
                        marginBlockEnd: token("space.0")
                    })}
                >
                    {tutorialIntroduction?.tutorialIntroductionName}
                </h2>
            )}

            {tutorialIntroduction?.tutorialIntroductionDetails && (
                <div
                    css={css({
                        marginBlockEnd: token("space.250")
                    })}
                >
                    <RichTextComponent
                        name={
                            tutorialIntroduction?.tutorialIntroductionName ?? ""
                        }
                        text={getRichText(
                            tutorialIntroduction?.tutorialIntroductionDetails ??
                                ""
                        )}
                    />
                </div>
            )}

            {tutorialIntroduction?.embedLink && (
                <AgileVideo
                    embedLink={tutorialIntroduction?.embedLink ?? ""}
                    title={tutorialIntroduction?.tutorialIntroductionName ?? ""}
                    thumbnail={tutorialIntroduction?.tutorialIntroductionAsset}
                />
            )}
        </div>
    );
};
